import catalogData from '../../../../catalog-data.json';
import { CatalogItem } from '../models/catalog-item';

export function getCatalogItemsFromServer(keys: string[]) {
  const catalogItems: CatalogItem[] = [];

  for (const key of keys) {
    const catalogPrograms = catalogData.programs as CatalogItem[]; // Needed due to JSON type conversion
    const foundCatalogItem = catalogPrograms.find((program) => program.key === key);

    if (foundCatalogItem) {
      catalogItems.push(foundCatalogItem);
    }
  }

  return catalogItems;
}
